import { render } from "./AppMain.vue?vue&type=template&id=55358008&scoped=true"
import script from "./AppMain.vue?vue&type=script&lang=ts"
export * from "./AppMain.vue?vue&type=script&lang=ts"

import "./AppMain.vue?vue&type=style&index=0&id=55358008&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-55358008"

export default script